import type { PlatformLayout } from "./types";

/**
 * Level 0 — The Liminal Atrium.
 *
 *  - platform1 raised to y=2.2 so its bottom (2.0) clears a grounded cat's
 *    capsule top (1.4); at y=1.5 cats permanently clipped with it.
 *  - platform2 trimmed 3.5 → 2.5 and platform3 5 → 4 so there is a 2u clear
 *    x gap between them: a vertical-jump corridor at x≈1.
 *  - platform4 (the dial ledge) lowered 4.0 → 3.6 on 2026-09-26: a 2.0u rise
 *    across a 0.5u gap was a near-vertical precision jump (tools/playtest
 *    hops.mjs: running jumps 0/30). TutorialGate's dial moved down with it.
 *  - platform2 (the window sill both cats spawn on) widened on 2026-09-27
 *    from x[-2.25, 0.25] to x[-3.0, 0.75]. The route back west (platform3 →
 *    platform2) was the hardest jump in the tutorial: 76/780 grid
 *    attempts, 48% for Basil with human noise. A running jump from
 *    platform3 flies ~4.5u (Basil) / ~4.8u (Minna), so launching from
 *    platform3's edge, where players naturally jump, landed on the sill's
 *    far end at full speed and ran off it, and short standing jumps fell
 *    into the 1.75u gap. Now the left edge meets platform1 (an overshoot
 *    drops 0.8u onto platform1, not to the floor), the gap to platform3 is
 *    1.25u (the floor→platform3 corridor at x≈1.4 stays open), and it
 *    still sits inside the front window frame (x[-3.27, 3.27]).
 */
export const LIMINAL_ATRIUM_PLATFORMS: PlatformLayout = {
  level: "LiminalAtrium",
  groundTopY: 0,
  platforms: [
    { name: "platform1", w: 4, x: -5, y: 2.2 },
    { name: "platform2", w: 3.75, x: -1.125, y: 3.0 },
    { name: "platform3", w: 4, x: 4, y: 2.0 },
    { name: "platform4", w: 3, x: 8, y: 3.6 },
    { name: "platform5", w: 6, x: -8, y: 3.5 },
  ],
};
